import {Box, HBox} from '../../../../../../src/components/core/view';
import {CustomText, H6Text} from '../../../../../../src/components/core/text';
import {
  useColorThemeType,
  useFontTheme,
} from '../../../../../../src/appStyles/hooks/theme';

import {HomeScreens} from '@buncha/home/navigation/types';
import {Modules} from '@buncha/utils/types';
import React from 'react';
import {RunInfo} from '../../../../../../src/driver/types/orderDetails';
import {StyleSheet} from 'react-native';
import {useGetLocale} from '@buncha/localization/hooks';

interface OrderInfoHeaderProps {
  runInfo: RunInfo | undefined;
  itemCount: number;
}

const OrderInfoHeader: React.FC<OrderInfoHeaderProps> = props => {
  const theme = useColorThemeType('main');
  const muli = useFontTheme('muli');
  const {body} = useGetLocale(Modules.driver, HomeScreens.Driver) ?? {};
  return (
    <Box>
      <HBox style={styles.countBox}>
        <H6Text
          style={[
            styles.textAlignment,
            {
              color: theme?.text?.blue?.[300],
              fontFamily: muli?.[700]?.normal,
            },
          ]}>
          {body?.orderDetails?.[0]}
        </H6Text>
        <CustomText>
          {props.itemCount}
          {body?.orderDetails?.[1]}
        </CustomText>
      </HBox>
    </Box>
  );
};

export default React.memo(OrderInfoHeader);

const styles = StyleSheet.create({
  textAlignment: {
    textAlign: 'left',
  },
  countBox: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    marginRight: 10,
    gap: 10,
  },
});
